module.exports = __webpack_public_path__ + "startpage-746fed5a/template-3-2x-b7462c37c2aededcfbeeba676ff1d246.jpg";